import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Text } from 'shared/components/text';
import { useLocale } from 'shared/library/i18n/use-locale';

type BreedersMapStatusProps = {
  viewing: number;
  total: number;
  loading: boolean;
};

export function BreedersMapStatus({ viewing, total, loading }: BreedersMapStatusProps) {
  const { t } = useTranslation('screens');
  const { locale } = useLocale();

  return (
    <View
      pointerEvents={'none'}
      testID={'breeders-map-status'}
      className={
        'border-brand-brown-dark/30 shadow-brand-brown/5 self-start rounded-md border bg-white shadow'
      }
    >
      {!loading && (
        <View className={'px-3 py-2.5'}>
          <Text
            testID={'breeders-map-count'}
            accessibilityLiveRegion={'polite'}
            className={'text-brand-brown text-sm font-medium tabular-nums leading-tight'}
            numberOfLines={1}
          >
            {t('breeders.index_breeders_map.viewing_x_of_x', {
              viewing: viewing.toLocaleString(locale),
              of: total.toLocaleString(locale),
            })}
          </Text>
        </View>
      )}
      <View
        className={`flex-row items-center gap-2 px-3 py-2 ${loading ? '' : 'border-brand-brown-dark/15 border-t'}`}
      >
        <View className={'bg-brand-cream-light size-3 rounded-full border-2 border-orange-500'} />
        <Text className={'text-brand-brown text-xs font-medium'} numberOfLines={1}>
          {t('breeders.index_breeders_map.active_listing_legend')}
        </Text>
      </View>
    </View>
  );
}
